import { MapContainer, TileLayer, useMap, ZoomControl } from 'react-leaflet';
import SchoolMarker from './SchoolMarker';
import api from '../services/api';
import 'leaflet/dist/leaflet.css';
import { useParams, useNavigate } from 'react-router-dom';
import * as L from 'leaflet';
import { useMapEvents } from 'react-leaflet';
import React, { useState, useEffect, useCallback } from 'react';

const MapBounds = ({ schools }) => {
  const map = useMap();
  useEffect(() => {
    const bounds = schools
      .map(s => s.latlng)
      .filter(Boolean);
    if (bounds.length > 0) {
      map.fitBounds(bounds);
    }
  }, [map, schools]);
  return null;
};

const MapaEscola = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [school, setSchool] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [mensagem, setMensagem] = useState({ tipo: '', texto: '' });

  const mostrarMensagem = useCallback((tipo, texto) => {
    setMensagem({ tipo, texto });
    setTimeout(() => setMensagem({ tipo: '', texto: '' }), 4000);
  }, []);

  const atualizarRegistro = useCallback(async (id, dadosAtualizacao) => {
    try {
      const response = await api.put(`/escola/${id}`, dadosAtualizacao);
      if (response && response.data) {
        mostrarMensagem('success', 'Localização da escola atualizada com sucesso!');
        navigate(`/escola/`);
      } else {
        mostrarMensagem('error', 'Resposta da API inválida ao atualizar.');
      }
    } catch (error) {
      mostrarMensagem('error', `Erro ao atualizar: ${error.message}`);
    }
  }, [mostrarMensagem, navigate]);

  const ClickHandler = () => {
    useMapEvents({
      click(e) {
        const confirmar = window.confirm(`Deseja definir a localização da escola para estas coordenadas?\nLat: ${e.latlng.lat.toFixed(6)}, Lng: ${e.latlng.lng.toFixed(6)}`);

        if(confirmar){
          const dadosAtualizacao = {
            geom_localizacao: `POINT(${e.latlng.lng} ${e.latlng.lat})`,
            georreferenciado: true
          };

          atualizarRegistro(id, dadosAtualizacao);
        }
      }
    });
    return null;
  };

  useEffect(() => {
    const fetchEscola = async () => {
      try {
        const response = await api.get(`/escola/${id}`);
        if (!response.data || !response.data.data) {
          setError('Escola não encontrada.');
          setLoading(false);
          return;
        }

        const schoolData = response.data.data; 
        let lat = null;
        let lon = null;
        
        const geom = schoolData.geom_geojson;

        if (geom && typeof geom === 'object' && geom.type === 'Point' && Array.isArray(geom.coordinates)) {
            lon = geom.coordinates[0];
            lat = geom.coordinates[1];
        }

        const latlng = (lat !== null && lon !== null && !isNaN(lat) && !isNaN(lon)) ? new L.LatLng(lat, lon) : null;

        setSchool({
          ...schoolData,
          latlng: latlng
        });

      } catch (err) {
        console.error("Erro ao buscar escola:", err);
        setError(err.message || 'Erro ao carregar a escola.');
      } finally {
        setLoading(false);
      }
    };

    if (id) {
      fetchEscola();
    }
  }, [id]);
  
  const mapCenter = [-15.77972, -47.92972];
  const mapZoom = 4;

  return (
    <div style={{ height: '100vh', width: '100%', position: 'relative' }}>
      {mensagem.texto && (
        <div 
          style={{ 
            position: 'absolute', 
            top: '10px', 
            left: '50%', 
            transform: 'translateX(-50%)', 
            zIndex: 1001, 
            padding: '10px 20px',
            borderRadius: '5px',
            color: 'white',
            backgroundColor: mensagem.tipo === 'success' ? '#28a745' : '#dc3545'
          }}
        >
          {mensagem.texto}
        </div>
      )}
      
      <div style={{position: 'absolute', top: 10, left: 10, zIndex: 1000, background: 'white', padding: '10px', borderRadius: '5px'}}>
        <button onClick={() => navigate('/escola')} className="btn-back">
          <i className="fas fa-arrow-left"></i> Voltar
        </button>
        <h5 style={{marginTop: '10px'}}>Clique no mapa para definir a localização da escola.</h5>
        {school && <p>Escola: <strong>{school.nome_escola}</strong></p>}
      </div>

      {loading && <p style={{textAlign: 'center', marginTop: '20%'}}>Carregando mapa...</p>}
      {error && <p style={{ color: 'red', textAlign: 'center', marginTop: '20%' }}>{error}</p>}

      {!loading && !error && (
        <MapContainer
          center={school && school.latlng ? school.latlng : mapCenter}
          zoom={school && school.latlng ? 15 : mapZoom}
          style={{ height: '100%', width: '100%' }}
          zoomControl={false}
        >
          <ZoomControl position="topright" />
          <ClickHandler />
          <TileLayer
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            attribution="&copy; OpenStreetMap contributors"
          />

          {school && school.latlng && (
              <SchoolMarker school={school} />
          )}

          {school && school.latlng && <MapBounds schools={[school]} />}
        </MapContainer>
      )}
    </div>
  );
};

export default MapaEscola;
